import { Box } from 'braid-design-system';
import type { ReactNode } from 'react';

import * as styles from './style.css';

interface CarouselProps {
  items: ReactNode[];
}

export const LegacyCarousel = (props: CarouselProps) => (
  <Box className={styles.carousel}>
    {props.items.map((item, index) => (
      <Box key={index} className={styles.item}>
        {item}
      </Box>
    ))}
  </Box>
);
